// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "AccordionItem-module--wrapper--v9PU-";
export var heading = "AccordionItem-module--heading--FnSjF";
export var icon = "AccordionItem-module--icon--FrXHn";
export var isActive = "AccordionItem-module--isActive--Rr6fN";
export var title = "AccordionItem-module--title--1JwX2";
export var description = "AccordionItem-module--description---TRMu";
export var isOpen = "AccordionItem-module--isOpen--l5JLy";
export var innerDescription = "AccordionItem-module--innerDescription--PbS52";